import { render, staticRenderFns } from "./admin.roles.vue?vue&type=template&id=99bd7c9a&"
import script from "./admin.roles.vue?vue&type=script&lang=js&"
export * from "./admin.roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports